import { useMemo, useState } from "react";
import { Col, Modal, Carousel, Button } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl,tags,url,media }) => {
  const [show, setShow] = useState(false);

  const normalizedMedia = useMemo(() => {
    if (!Array.isArray(media)) return [];
    return media.map((item) => {
      if (typeof item === 'string') {
        const lower = item.toLowerCase();
        const isVideo = /(\.mp4|\.webm|\.ogg)$/.test(lower);
        return { type: isVideo ? 'video' : 'image', src: item };
      }
      if (item && typeof item === 'object') {
        return { type: item.type === 'video' ? 'video' : 'image', src: item.src };
      }
      return null;
    }).filter(Boolean);
  }, [media]);

  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx" onClick={handleOpen} style={{cursor: 'pointer'}}>
        <img  src={imgUrl} alt={title} />
        <div className="proj-txtx">
          <h4>{title}</h4>
         
        </div>
      </div>

      {show && (
        <style>{`
          .modal-dialog.project-modal { 
            margin-top: 80px; /* avoid navbar overlap */
            max-width: 900px; /* wider dialog */
            width: calc(100vw - 32px);
          }
          .modal-dialog.project-modal .modal-content {
            max-height: 85vh; /* less tall */
          }
          .modal-dialog.project-modal .modal-body {
            overflow: auto; /* scroll body when needed */
          }
        `}</style>
      )}
      <Modal show={show} onHide={handleClose} centered size="lg" dialogClassName="project-modal">
        <Modal.Header closeButton>
          <Modal.Title style={{color: '#000'}}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
          {normalizedMedia.length > 0 ? (
            <Carousel interval={null} indicators={normalizedMedia.length > 1}>
              {normalizedMedia.map((m, idx) => (
                <Carousel.Item key={idx}>
                  {m.type === 'video' ? (
                    <video controls style={{width: '100%', height: 'auto'}}>
                      <source src={m.src} />
                    </video>
                  ) : (
                    <img
                      src={m.src}
                      alt={`${title} media ${idx + 1}`}
                      style={{width: '100%', height: 'auto'}}
                    />
                  )}
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <img src={imgUrl} alt={title} style={{width: '100%', height: 'auto'}} />
          )}
          {description && (
            <p style={{color: '#000', margin:12}}>{description}</p>
          )}
          {tags && Array.isArray(tags) && tags.length > 0 && (
            <div style={{marginLeft:12,marginTop: 12, display: 'flex', flexWrap: 'wrap', gap: 8}}>
              {tags.map((t) => (
                <span key={t} className="badge p-2  rounded-lg bg-success">{t}</span>
              ))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {url && (
            <Button variant="success" as="a" href={url} target="_blank" rel="noopener noreferrer">
              Visit Project
            </Button>
          )}
          <Button variant="secondary" onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </Col>
  )
}
